var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 11.5C9.75 11.9142 9.41421 12.25 9 12.25C8.58579 12.25 8.25 11.9142 8.25 11.5C8.25 11.0858 8.58579 10.75 9 10.75C9.41421 10.75 9.75 11.0858 9.75 11.5Z",
    fill: "#FF9F1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 4.75C9.5625 4.43934 9.31066 4.1875 9 4.1875C8.68934 4.1875 8.4375 4.43934 8.4375 4.75V9.25C8.4375 9.56066 8.68934 9.8125 9 9.8125C9.31066 9.8125 9.5625 9.56066 9.5625 9.25V4.75Z",
    fill: "#FF9F1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0.4375C4.5472 0.4375 0.9375 4.0472 0.9375 8.5C0.9375 12.9528 4.5472 16.5625 9 16.5625C13.4528 16.5625 17.0625 12.9528 17.0625 8.5C17.0625 4.0472 13.4528 0.4375 9 0.4375ZM2.0625 8.5C2.0625 4.66852 5.16852 1.5625 9 1.5625C12.8315 1.5625 15.9375 4.66852 15.9375 8.5C15.9375 12.3315 12.8315 15.4375 9 15.4375C5.16852 15.4375 2.0625 12.3315 2.0625 8.5Z",
    fill: "#FF9F1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningCircle);
export default __webpack_public_path__ + "static/media/warning-circle.73ad1c440c048aec575a5b817bb250d0.svg";
export { ForwardRef as ReactComponent };